/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReferralsRoute extends Route {
  reactEnabled() {
    return true;
  }
}
export default ReactRoute(ReferralsRoute);
